document.addEventListener('click', function (event) {
  var choose = event.target.closest('.nx-mobile-cta a');
  if (choose) {
    event.preventDefault();
    var options = document.querySelector('.nx-option');
    if (options) options.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }
  var thumb = event.target.closest('[data-nx-thumb]');
  if (thumb) {
    var main = document.querySelector('[data-nx-main]');
    if (main) {
      main.src = thumb.dataset.src;
      main.alt = thumb.dataset.alt || '';
    }
    document.querySelectorAll('[data-nx-thumb]').forEach(function (item) {
      item.setAttribute('aria-current', String(item === thumb));
    });
  }

  var swatch = event.target.closest('[data-nx-swatch]');
  if (swatch) {
    var select = document.querySelector('[data-nx-variant-select]');
    if (select) {
      select.value = swatch.dataset.variant;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    document.querySelectorAll('[data-nx-swatch]').forEach(function (item) {
      item.classList.toggle('is-active', item === swatch);
    });
    var label = document.querySelector('[data-nx-color-label]');
    if (label) label.textContent = swatch.dataset.label;
  }
});

document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-nx-variant-select]')) return;
  var option = event.target.options[event.target.selectedIndex];
  document.querySelectorAll('[data-nx-price]').forEach(function (price) {
    if (option) price.innerHTML = option.dataset.price || price.innerHTML;
  });
});

